
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import RecommdCard from '../RecommdCard/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    NewSwiper,
    LazyImg,
    RecommdCard
  }
})
export default class HeaderPanel extends Vue {
  activeIndex: number = 0

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  get CityStore() {
    return this.$store.$tonghao.Cities
  }

  get HomeStore() {
    return this.$store.$homeV2.dataSource
  }

  handleClick() {}

  handleChange(index: number): void {
    if (this.activeIndex === index) return

    this.activeIndex = index
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
